import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthConfig, OAuthService} from 'angular-oauth2-oidc';
import {jwtDecode} from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class CustomOAuthService {
  constructor(private readonly oauthService: OAuthService) {
  }

  private storedAuth: any = null;

  getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }

  configure(conf: AuthConfig): void {
    this.oauthService.configure(conf)
  }

  fetchTokenUsingPasswordFlow(userName: string, password: string, headers?: HttpHeaders): Promise<object> {
    const r = this.oauthService.fetchTokenUsingPasswordFlow(userName, password, headers)
    this.setIdentityClaims()
    return r;
  }

  getIdentityClaims() {
    if (this.storedAuth != null) {
      return this.storedAuth
    } else
      this.storedAuth = JSON.parse(localStorage.getItem('id_token_claims_obj'))
    return this.storedAuth;
  }

  hasValidAccessToken() {
    try {
      const token = this.oauthService.getAccessToken();
      if (!token) {
        return false;
      }

      const decoded: any = jwtDecode(token);
      if (!decoded || !decoded.exp) {
        return false;
      }

      return decoded.exp > Math.floor(Date.now() / 1000);
    } catch {
      return false;
    }
  }

  setIdentityClaims(): any {
    const claims = this.oauthService.getIdentityClaims();
    if (claims) {
      this.storedAuth = claims;
    }

    const token = this.oauthService.getAccessToken();
    this.storedAuth = this.transformToSpringAuth(token ? jwtDecode<any>(token) : null);
    localStorage.setItem("id_token_claims_obj", JSON.stringify(this.storedAuth))
  }

  authorizationHeader(): string {
    return this.oauthService.authorizationHeader();
  }

  // se precisar, você pode expor outros métodos também:
  initLoginFlow() {
    return this.oauthService.initLoginFlow();
  }

  logOut(v?) {
    return this.oauthService.logOut(v);
  }

  transformToSpringAuth(obj1: any) {
    if (obj1 == null) return null;

    const exp = obj1.exp;
    const userDetails = obj1.userDetails;

    const authorities = userDetails.authorities || [];
    const roles = userDetails.roles || [];

    const details = {
      ...userDetails,
      enabled: true,
      accountNonExpired: true,
      accountNonLocked: true,
      credentialsNonExpired: true,
    };

    const principal = {
      ...details
    };

    return {
      exp,
      authorities,
      details,
      authenticated: true,
      userAuthentication: {
        authorities,
        details: {
          grant_type: "password",
          scope: "all",
          username: userDetails.username
        },
        authenticated: true,
        principal,
        credentials: null,
        name: userDetails.username
      },
      clientOnly: false,
      oauth2Request: {
        clientId: "client",
        scope: ["all"],
        requestParameters: {
          grant_type: "password",
          scope: "all",
          username: userDetails.username
        },
        resourceIds: ["restservice"],
        authorities: [],
        approved: true,
        refresh: false,
        redirectUri: null,
        responseTypes: [],
        extensions: {},
        grantType: "password",
        refreshTokenRequest: null
      },
      credentials: "",
      principal,
      name: userDetails.username
    };
  }

  setOffice(office) {
    var c = JSON.parse(localStorage.getItem('id_token_claims_obj'))
    c.details.office = office
    this.storedAuth = c
    localStorage.setItem("id_token_claims_obj", JSON.stringify(c))
  }

}
